module.exports = __webpack_public_path__ + "img/image 03.45e2bb9f.png";